<script setup lang="ts">
import type { Slot } from 'vue';
import { ref } from 'vue';

import type { TpgWorkflowToastProps } from './component-types';

interface GrammarWorkflowToastSlots {
  'default'?: Slot;
  'leading-badge'?: Slot;
  'trailing-badge'?: Slot;
  'trailing-tertiary-button'?: Slot;
}

const props = withDefaults(defineProps<TpgWorkflowToastProps>(), {
  isOpen: false,
  duration: -1,
  position: '',
  isQueued: false,
});

const emit = defineEmits<{
  (event: 'tpgShow'): void;
  (event: 'tpgAfterShow'): void;
  (event: 'tpgHide'): void;
  (event: 'tpgAfterHide'): void;
  (event: 'click'): void;
}>();

const slots = defineSlots<GrammarWorkflowToastSlots>();

const toastRef = ref();

function pauseAutoHide() {
  toastRef.value?.pauseAutoHide();
}

function resumeAutoHide() {
  toastRef.value?.resumeAutoHide();
}
defineExpose({ pauseAutoHide, resumeAutoHide });
</script>

<template>
  <tpg-workflow-toast
    ref="toastRef"
    v-bind="props"
    @tpg-show="() => emit('tpgShow')"
    @tpg-after-show="() => emit('tpgAfterShow')"
    @tpg-hide="() => emit('tpgHide')"
    @tpg-after-hide="() => emit('tpgAfterHide')"
  >
    <div v-if="slots['leading-badge']" slot="leading-badge">
      <slot name="leading-badge" />
    </div>

    <div v-if="slots['trailing-badge']" slot="trailing-badge">
      <slot name="trailing-badge" />
    </div>

    <div v-if="slots['trailing-tertiary-button']" slot="trailing-tertiary-button">
      <slot name="trailing-tertiary-button" />
    </div>

    <slot />
  </tpg-workflow-toast>
</template>
